import * as React from 'react';
// import PropTypes from 'prop-types';
import './article-tags.scss';

// brand styles found here:
// http://psunewstest.s3-website-us-east-1.amazonaws.com/storybook/?path=/story/paragraphs-article-tags--default

const ArticleTags = (props) => (
	<section className={`article-tags-module__outer ${props.className}`}>
		{/* <h3 className="article-tags-module__title">Tags</h3> */}
		<ul className="article-tags-module__list">
			{/* {console.log('tags: ', props.tags)} */}
			{props.tags.map((tag) => (
				<li className="article-tags-module__listItem" key={tag.id}>
					<a
						href={`/resources/?tag=${encodeURI(tag.title)}`}
						className="tag-module__tag"
					>
						{tag.title}
					</a>
				</li>
			))}

			{/* <li className="article-tags-module__listItem">
				<a href="#" className="tag-module__tag">
					Nitrogen
				</a>
			</li>
			<li className="article-tags-module__listItem">
				<a href="#" className="tag-module__tag">
					dairy cow nitrogen efficiency
				</a>
			</li> */}
		</ul>
	</section>
);

ArticleTags.propTypes = {
	// lead: PropTypes.string
};

ArticleTags.defaultProps = {
	// lead: `Add some tags please`
};

export default ArticleTags;
